

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Typography, Box, Grid, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Icon } from "@iconify/react";
import Loader from '../../../components/loader';
import '../countryManagement.css';
import { countryManagementGetById } from '../countryManagement.service'

const CountryManagementView = () => {

  const { id } = useParams();
  const navigate = useNavigate();
  const [countryData, setCountryData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getcountryData();
  }, []);

  const getcountryData = async () => {
    try {
      const data = await countryManagementGetById(id);
      setCountryData(data.data);
    } catch (error) {
      console.error('Error fetching user type by ID:', error);
    };
  }

  return (
    <Box>
      <Grid container alignItems={'center'}>
        <Grid size={{ xs: 12, sm: 4, md: 3, lg: 3, xl: 3 }}>
          <Typography style={{ fontSize: 30, fontWeight: 700 }}>Country Setup View</Typography>
        </Grid>
        <Grid size={{ xs: 6, sm: 7.5, md: 8.5, lg: 8.5, xl: 8.5 }} textAlign={'end'}>
          <Button variant="contained" className='createBtn' type="submit" onClick={() => { setLoading(true); navigate(`/countryManagementCreation/${id}?type=edit`) }}>Edit</Button>
        </Grid>
        <Grid size={{ xs: 2, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }} textAlign={'end'}>
          <Icon icon="ei:arrow-left" data-testid="back-icon" onClick={() => navigate('/countryManagement')} width="30" height="30" className='backIcon' />
        </Grid>
      </Grid>

      <Grid container mt={2}>
        <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>
          <Grid container mt={2}>
            <Grid size={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
              <Typography className='contentLeft'>Country Name</Typography>
            </Grid>
            <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
              <Typography className='contentLeft'> :</Typography>
            </Grid>
            <Grid size={{ xs: 5, sm: 5, md: 8, lg: 8, xl: 8 }}>
              <Typography className='contentRight'>{countryData?.countryName ?? "-"}</Typography>
            </Grid>
          </Grid>

          <Grid container mt={2}>
            <Grid size={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
              <Typography className='contentLeft'>Country Code (ISO)   </Typography>
            </Grid>
            <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
              <Typography className='contentLeft'> :</Typography>
            </Grid>
            <Grid size={{ xs: 5, sm: 5, md: 8, lg: 8, xl: 8 }}>
              <Typography className='contentRight'>{countryData?.countryCode ?? "-"}</Typography>
            </Grid>
          </Grid>

          <Grid container mt={2}>
            <Grid size={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
              <Typography className='contentLeft'>Region</Typography>
            </Grid>
            <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
              <Typography className='contentLeft'> :</Typography>
            </Grid>
            <Grid size={{ xs: 5, sm: 5, md: 8, lg: 8, xl: 8 }}>
              <Typography className='contentRight'>{countryData?.regionName ?? "-"}</Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}>

          <Grid container mt={2}>
            <Grid size={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
              <Typography className='contentLeft'>Currency</Typography>
            </Grid>
            <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
              <Typography className='contentLeft'> :</Typography>
            </Grid>
            <Grid size={{ xs: 5, sm: 5, md: 8, lg: 8, xl: 8 }}>
              <Typography className='contentRight'>{countryData?.currency ?? "-"}</Typography>
            </Grid>
          </Grid>

          <Grid container mt={2}>
            <Grid size={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
              <Typography className='contentLeft'>Timezone </Typography>
            </Grid>
            <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
              <Typography className='contentLeft'> :</Typography>
            </Grid>
            <Grid size={{ xs: 5, sm: 5, md: 8, lg: 8, xl: 8 }}>
              <Typography className='contentRight'>{countryData?.timezone ?? "-"}</Typography>
            </Grid>
          </Grid>

          <Grid container mt={2}>
            <Grid size={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
              <Typography className='contentLeft'>Available Solutions   </Typography>
            </Grid>
            <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
              <Typography className='contentLeft'> :</Typography>
            </Grid>
            <Grid size={{ xs: 5, sm: 5, md: 8, lg: 8, xl: 8 }}>
              <Typography className='contentRight'>
                {countryData?.countrySolution?.map((type) => type?.name).join(', ')}</Typography>
            </Grid>
          </Grid>

        </Grid>
      </Grid>

      {loading && <Loader />}
    </Box>
  );
};

export default CountryManagementView;

